import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BreakdownDTO} from '../../models/breakdown';
import {BreakdownService} from '../../services/breakdown.service';
@Component({
  selector: 'app-accounts',
  templateUrl: './breakdowns-close.component.html',
  styleUrls: ['./breakdowns-close.component.css']
})
export class BreakdownsCloseComponent implements OnInit {

  @Output() onCloseValidation = new EventEmitter<boolean>();

  comment: string;
  breakdownId: number;

  constructor(private breakdownService: BreakdownService,
              public activeModal: NgbActiveModal) {
  }

  /**
   * Loads a list of accounts to display in the table
   * Also loads a list of groups and sucbscription plans to display in the filters fields.
   */
  ngOnInit() {
  }

  onClosureClick() {
    this.activeModal.close(null);
    this.breakdownService.patch({
      id: this.breakdownId,
      maintenanceTaskComment: this.comment,
      status: 'CLOSED'
    } as BreakdownDTO)
      .subscribe(() => this.onCloseValidation.emit(true));
  }
}



// WEBPACK FOOTER //
// ./src/app/breakdowns/breakdowns-close/breakdowns-close.component.ts